import styled from 'styled-components'
import COLORS from '@colors'

export const Main = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${COLORS.whiteF3};
  z-index: 6;
`

export const TopContent = styled.div`
  display: flex;
  height: 230px;
  padding: 18px;
`

export const LeftContent = styled.div`
  width: 254px;
  margin-right: 8px;
`

export const RightContent = styled.div`
  width: calc(100% - 254px);
  margin-left: 8px;
`

export const GoBack = styled.button`
  border: 0;
  border-radius: 4px;
  background-color: ${COLORS.whiteA1};
  color: ${COLORS.whiteF3};
  padding: 4px 5px;
  cursor: pointer;
  width: 142px;
  height: 25px;
  outline: 0;
  display: flex;
  align-items: center;

  svg {
    margin-right: 4px;
  }
`

export const Header = styled.h3`
  font-weight: bold;
  font-size: 16px;
  color: ${COLORS.leather};
  margin-bottom: 31px;
`

export const Text = styled.p`
  font-size: ${props => (props.isLabel ? '10px' : '14px')};
  color: ${props => (props.isLabel ? COLORS.whiteA1 : COLORS.gray45)};
  font-weight: ${props => (props.normal ? 'normal' : 'bold')};
  text-transform: ${props => (props.isLabel ? 'uppercase' : 'none')};
  margin-bottom: ${props => (props.isLabel ? '8px' : props.margin || '0')};
`
export const ContentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  ${props => props.center && 'justify-content: center;'}

  height: 230px;
`

export const InnerContent = styled.div`
  min-width: 138px;
`

export const ReportButton = styled.button`
  width: 218px;
  height: 32px;
  border: 0;
  border: 1px solid ${COLORS.gray45};
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${COLORS.gray45};
  padding: 8px 0;
  background-color: transparent;
  outline: 0;
`
